import { useTranslation } from 'react-i18next';
import type { OrderBlockMessage } from '~/graphql/graphql';
import { formatBlockMessage } from '~/utils';

export function UnprocessedBlockMessages({
  messages,
  className = 'flex flex-col gap-2',
  itemClassName = 'text-xs text-warning-800 flex flex-col',
  'data-testid': dataTestId,
}: Readonly<{
  messages: readonly OrderBlockMessage[];
  className?: string;
  itemClassName?: string;
  'data-testid'?: string;
}>) {
  const { t, i18n } = useTranslation('order');
  return (
    <ul className={className} data-testid={dataTestId}>
      {messages.map((message) => (
        <li key={message.id} className={itemClassName}>
          {formatBlockMessage(message.message).map((line, index) => (
            <span key={`${message.id}-${index}`} className="block">
              {i18n.exists(line) ? t(line) : line}
            </span>
          ))}
        </li>
      ))}
    </ul>
  );
}
